import { FilterList, Radio } from '@versita/frontend/campus-ui-web';
import { useAppDispatch } from '../../state';
import {
  FilterName,
  setStatusFilters,
  setAcademicYear,
} from '../../state/slices/timetableManagerSlice';
import {
  getCurrentAcademicYear,
  getNextAcademicYear,
} from '@versita/shared/timetable-utils';

export const AdminTableFilters = ({
  flavour,
}: {
  flavour: 'STUDENT' | 'COURSE';
}) => {
  const dispatch = useAppDispatch();
  const publishedStatuses = [
    { label: 'Published', value: 'published' },
    { label: 'Unpublished', value: 'unpublished' },
  ];
  if (flavour === 'STUDENT') {
    publishedStatuses.push({
      label: 'Will Not Publish',
      value: 'willNotPublish',
    });
  }
  const currentAcademicYear = getCurrentAcademicYear();
  const nextAcademicYear = getNextAcademicYear();
  const academicYears = [
    {
      id: currentAcademicYear,
      value: currentAcademicYear,
      label: currentAcademicYear.replace('.', '/'),
    },
    {
      id: nextAcademicYear,
      value: nextAcademicYear,
      label: nextAcademicYear.replace('.', '/'),
    },
  ];

  const handleFilterByStatus = (selectedValues: FilterName[]) => {
    dispatch(setStatusFilters([...selectedValues]));
  };

  return (
    <>
      <Radio
        legend="Academic Year"
        items={academicYears}
        name="selectedAcademicYear"
        description="Publish timetables for this year or the next one"
        style={{ marginBottom: 0 }}
        defaultValue={currentAcademicYear}
        inputProps={{
          onChange: (e) => dispatch(setAcademicYear(e.currentTarget.value)),
        }}
      />
      <FilterList
        items={publishedStatuses}
        filterDescription="Filter By Status"
        handleFilter={handleFilterByStatus}
      />
    </>
  );
};
